"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormToggler = exports.ToggleType = void 0;
var ToggleType;
(function (ToggleType) {
    ToggleType[ToggleType["List"] = 0] = "List";
    ToggleType[ToggleType["Fields"] = 1] = "Fields";
})(ToggleType = exports.ToggleType || (exports.ToggleType = {}));
var FormToggler = /** @class */ (function () {
    function FormToggler(formTogglerWrapper) {
        var _this = this;
        this.formTogglerWrapper = formTogglerWrapper;
        this.togglerList = this.formTogglerWrapper.querySelector('.rcg-transfer__form-toggler--list');
        this.togglerFields = this.formTogglerWrapper.querySelector('.rcg-transfer__form-toggler--fields');
        this.togglerList.addEventListener('click', function (e) { return _this.toggle(_this.togglerList, ToggleType.List); });
        this.togglerFields.addEventListener('click', function (e) { return _this.toggle(_this.togglerFields, ToggleType.Fields); });
    }
    FormToggler.prototype.toggle = function (elem, type) {
        var activeElement = this.formTogglerWrapper.querySelector('.' + FormToggler.ACTIVE_TOGGLER_CLASS);
        if (activeElement && activeElement != elem) {
            activeElement.classList.remove(FormToggler.ACTIVE_TOGGLER_CLASS);
        }
        if (type == ToggleType.List) {
            document.querySelector('.rcg-transfer__form-container--from').classList.remove(FormToggler.ACTIVE_CONTAINER_CLASS);
            document.querySelector('.rcg-transfer__form-container--to').classList.remove(FormToggler.ACTIVE_CONTAINER_CLASS);
            document.querySelector('.rcg-transfer__form-container--transfer').classList.add(FormToggler.ACTIVE_CONTAINER_CLASS);
        }
        else {
            document.querySelector('.rcg-transfer__form-container--transfer').classList.remove(FormToggler.ACTIVE_CONTAINER_CLASS);
            document.querySelector('.rcg-transfer__form-container--from').classList.add(FormToggler.ACTIVE_CONTAINER_CLASS);
            document.querySelector('.rcg-transfer__form-container--to').classList.add(FormToggler.ACTIVE_CONTAINER_CLASS);
        }
        elem.classList.add(FormToggler.ACTIVE_TOGGLER_CLASS);
    };
    FormToggler.ACTIVE_TOGGLER_CLASS = 'rcg-transfer__form-toggler--active';
    FormToggler.ACTIVE_CONTAINER_CLASS = 'rcg-transfer__form-container--active';
    return FormToggler;
}());
exports.FormToggler = FormToggler;
